import { render, staticRenderFns } from "./index.vue?vue&type=template&id=322e3e43&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('322e3e43')) {
      api.createRecord('322e3e43', component.options)
    } else {
      api.reload('322e3e43', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=322e3e43&", function () {
      api.rerender('322e3e43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/navi/index.vue"
export default component.exports